module.exports = __webpack_public_path__ + "img/todov3-details3.8456274f.png";